import { useUserStatistics } from '@/api/hooks/user/useUserStatistics';
import user from '@/assets/icons/user.svg';
import userDeleted from '@/assets/icons/user-deleted.svg';
import StatCard from '../StatCard/StatCard';

const UserStatistics = () => {
  const { data: userStatistics } = useUserStatistics({from: null, to: null});
  
  const cards = [
    {
      title: 'Utilisateurs Total',
      value: userStatistics?.totalUsers,
      icon: user,
    },
    {
      title: 'utilisateurs masculins',
      value: userStatistics?.maleUsers,
      icon: user,
    },
    {
      title: 'utilisateurs féminins',
      value: userStatistics?.femaleUsers,
      icon: user,
    },
    {
      title: 'utilisateurs supprimés',
      value: userStatistics?.totalUsersDeleted,
      icon: userDeleted,
      valueColor: 'text-[#ED544E]',
    },
  ];

  return (
    <div className="py-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(({ icon, title, value, valueColor }, index) => (
          <StatCard
            key={index}
            icon={icon}
            title={title}
            value={value || 0}
            valueColor={valueColor}
          />
        ))}
      </div>
    </div>
  );
};

export default UserStatistics;
